import { CSSObject } from '@mui/material/styles';
import { baseTheme } from '../../base-theme';

// Maybe this should be in the theme at some point, but right now it doesn't make a lot of sense
export const outlineOffset = '0.125rem';

export function generateFocusRingStyles(focusClass: string, overrides?: CSSObject) {
    return {
        outlineColor: baseTheme.palette.focusRing,
        outlineWidth: baseTheme.tokens.borderWidth.md,
        outlineOffset,
        outlineStyle: 'none',
        zIndex: 1,
        [`&.${focusClass}`]: {
            outline: `${baseTheme.tokens.borderWidth.md} solid ${baseTheme.palette.focusRing}`,
            outlineStyle: 'solid',
            zIndex: 2,
        },
        ...(overrides || {}),
    };
}
